import React from 'react';

import Footer from 'Components/Footer';
import Header from 'Components/Header';
import Hero from 'Components/Hero';
import News from 'Components/News';

export default function Home() {
  return (
    <>
      <Header />
      <Hero bg='bg' overlay='dark' />
      <News
        limit={5}
        showViewAllButton={true}
        bg='black__bgr'
        overlay='light'
      />
      <Footer />
    </>
  );
}
